import { Inject, Injectable, InjectionToken } from '@angular/core';
import pino from 'pino';
import { EnvService } from '../env.service';

import { EXTERNAL_LOGGER, LogginService } from './logging-provider';

@Injectable({
  providedIn: 'root'
})
export class ServerLoggingService extends LogginService {

  _logger: pino.Logger;

  get logger() {
    return this._logger;
  }

  constructor(private env: EnvService, @Inject(EXTERNAL_LOGGER) externalLogger: pino.Logger) {
    super(env);
    if(externalLogger !== null) {
      this._logger = externalLogger;
    }
    else {
      console.warn('Creating build runner logger instance');
      this._logger = pino(<pino.LoggerOptions>{
        name: 'ssr-build-time-runner',
        level: this.env.logLevel || 'info'
      });
    }
  }
}